module.exports = __webpack_public_path__ + "img/head.ad66df44.png";